import { useCallback } from "react";
import { useLocation } from "react-router-dom";

import type { KaiTableFiltersPatch } from "@/components/table";
import { applyKaiBookingsTableFilters } from "@/features/bookings/bookingTableFilters";

/**
 * Applies a table-filters patch requested by Kai (via the
 * `apply_table_filters` SSE event) to the Bookings PropertyFilter query.
 * A mounted table picks up the change via the `kai-table-filters` window
 * event. Applied only when the target is Bookings AND the user is on
 * `/bookings` — off-page asks stay in chat.
 */
export function useApplyKaiTableFilters() {
  const location = useLocation();
  return useCallback(
    (page: unknown, filters: unknown) => {
      if (page !== "bookings") return;
      if (!location.pathname.startsWith("/bookings")) return;
      if (!filters || typeof filters !== "object") return;
      applyKaiBookingsTableFilters(filters as KaiTableFiltersPatch);
    },
    [location.pathname],
  );
}
